import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import BlockUi from 'react-block-ui';
import { useSubheader } from '../../../_metronic/layout/_core/MetronicSubheader';
import '../../components/jds/jds.css';
import './dashboard.css';

const ACTION_CLASS = 'jds-btn jds-btn--ghost jds-btn--brand jds-btn--sm dashboard-stat__action';

function StatCard({ label, value, to, href, tone }) {
  return (
    <div className={`jds-card dashboard-stat${tone === 'error' ? ' dashboard-stat--error' : ''}`}>
      <p className="dashboard-stat__label">{label}</p>
      <p className="dashboard-stat__value">{value}</p>
      {to && (
        <Link to={to} className={ACTION_CLASS}>
          Visualizar
        </Link>
      )}
      {href && (
        <a href={href} target="_blank" rel="noreferrer" className={ACTION_CLASS}>
          Visualizar
        </a>
      )}
    </div>
  );
}

export function DashboardJds() {
  const dashboard = useSelector(state => state.app.dashboard);
  const isLoading = useSelector(state => state.app.is_dashboard_loading);
  const { user } = useSelector(state => state.auth);
  const subheader = useSubheader();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: 'LOAD_DASHBOARD' });
    subheader.setBreadcrumbs([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="jds-scope">
      <h1 className="jds-title-lg mb-10">Seja bem-vindo, {user.name.split(' ')[0]}</h1>
      <BlockUi tag="div" blocking={isLoading}>
        <div className="dashboard-grid">
          <StatCard label="Clientes" value={dashboard.customers} to="/clientes" />
          <StatCard label="Cadastros hoje" value={dashboard.registers_today} to="/clientes" />
          {!!dashboard.paid && (
            <StatCard label="Clientes em dia" value={dashboard.paid} href="https://dashboard.pagar.me/" />
          )}
          {!!dashboard.active && (
            <StatCard label="Clientes ativos" value={dashboard.active} href="https://dashboard.pagar.me/" />
          )}
          <StatCard
            label="Cancelamentos de clientes hoje"
            value={dashboard.canceled}
            to="/cancelados/clientes"
            tone="error"
          />
          <StatCard
            label="Cancelamentos que pagaram 1x"
            value={dashboard.canceled_recent}
            to="/cancelados/recente"
            tone="error"
          />
        </div>
      </BlockUi>
    </div>
  );
}
